<script setup lang="ts">
import DrawingCanvas from "./DrawingCanvas.vue";

defineProps<{
  drawingId: number;
}>();
</script>

<template>
  <DrawingCanvas :drawingId="drawingId" />
</template>

<style></style>
